import useTranslation from "../../../hooks/useTranslation";
import { SubscriptionTier, SubscriptionType } from "../../../types";
import AutoRenewTooltip from "../../AutoRenewTooltip/AutoRenewTooltip";

export const SubscriptionExpirationText: React.FC<{
  autoRenews: boolean;
  subscriptionType: SubscriptionType;
  expirationDate: Date;
  hasAppStoreSubscription?: boolean;
  subscriptionTier: SubscriptionTier;
}> = ({
  autoRenews,
  subscriptionType,
  expirationDate,
  hasAppStoreSubscription,
  subscriptionTier,
}) => {
  const { t, m } = useTranslation();
  if (subscriptionType === SubscriptionType.Paddle && hasAppStoreSubscription) {
    return <>{t(m.TeamBilling.StartsOn)}</>;
  }

  if (autoRenews) {
    return (
      <>
        <span>{t(m.TeamBilling.AutoRenewsOn)} </span>
        <AutoRenewTooltip
          isAutoRenewEnabled={autoRenews}
          expirationDate={expirationDate}
          type={subscriptionType}
          subscriptionTier={subscriptionTier}
        />
      </>
    );
  }

  return <>{t(m.TeamBilling.ExpiresOn)}</>;
};
